var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewreservation = function SvgNewreservation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28704 0.538462C4.28704 0.24108 4.03319 0 3.72005 0C3.40691 0 3.15305 0.24108 3.15305 0.538462V1.67229C2.06493 1.75503 1.35059 1.95811 0.825779 2.45651C0.300969 2.95491 0.0871283 3.6333 0 4.66667H15C14.9129 3.6333 14.699 2.95491 14.1742 2.45651C13.6494 1.95811 12.9351 1.75503 11.847 1.67229V0.538462C11.847 0.24108 11.5931 0 11.28 0C10.9669 0 10.713 0.24108 10.713 0.538462V1.62465C10.21 1.61538 9.64628 1.61538 9.012 1.61538H5.98803C5.35373 1.61538 4.78998 1.61538 4.28704 1.62465V0.538462Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.14283V8.51426C15 11.1002 15 12.3933 14.1213 13.1966C13.2427 14 11.8284 14 9 14H6C3.17157 14 1.75736 14 0.878678 13.1966C8.9407e-08 12.3933 0 11.1002 0 8.51426V7.14283C0 6.56752 8.5216e-08 6.05618 0.00967509 5.59998H14.9903C15 6.05618 15 6.56752 15 7.14283ZM10.5 7.99998C10.8106 7.99998 11.0625 8.23024 11.0625 8.51426V9.3714H12C12.3106 9.3714 12.5625 9.60167 12.5625 9.88569C12.5625 10.1697 12.3106 10.4 12 10.4H11.0625V11.2571C11.0625 11.5411 10.8106 11.7714 10.5 11.7714C10.1894 11.7714 9.9375 11.5411 9.9375 11.2571V10.4H9C8.68935 10.4 8.4375 10.1697 8.4375 9.88569C8.4375 9.60167 8.68935 9.3714 9 9.3714H9.9375V8.51426C9.9375 8.23024 10.1894 7.99998 10.5 7.99998Z",
    fill: "#232323"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewreservation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new reservation.637063f7.svg";
export { ForwardRef as ReactComponent };